import { type ReactNode } from 'react';
import { css, styled } from 'styled-components';

const Card = styled.div`
  ${({ theme }) => css`
    padding: 64px 48px;
    background-color: ${theme.colorsV2.white};
    border-radius: 20px;
    color: ${theme.colorsV2.gray70};
    font-size: 24px;
    font-weight: 600;
    line-height: 1.333;
    letter-spacing: -0.25px;
    text-align: center;

    ${theme.mediaQueries.md} {
      padding-top: 96px;
      padding-bottom: 96px;
    }
  `}
`;

type BlankCardMessageProps = {
  readonly children: ReactNode;
};

export const BlankCardMessage = ({ children }: BlankCardMessageProps) => {
  return <Card>{children}</Card>;
};
